import { createApiReducers } from '../../utils/redux-rest-api/reducerHelper'
import * as rawApiOperations from './apiOperations'

const apiOperationNames = Object.keys(rawApiOperations) as (keyof typeof rawApiOperations)[]
export const apiReducers = createApiReducers<typeof rawApiOperations>(apiOperationNames)
